import React from "react";
import { Form, InputNumber, Select, Divider } from "antd";

const CURRENCY_OPTIONS = [
  { value: "MNT", label: "MNT" },
  { value: "USD", label: "USD" },
  { value: "CNY", label: "CNY" },
  { value: "EUR", label: "EUR" },
];

const COLLATERAL_OPTIONS = [
  { value: "Үл хөдлөх хөрөнгө", label: "Үл хөдлөх хөрөнгө" },
  { value: "Тээврийн хэрэгсэл", label: "Тээврийн хэрэгсэл" },
  { value: "Хадгаламж", label: "Хадгаламж" },
  { value: "Үнэт цаас", label: "Үнэт цаас" },
  { value: "Батлан даалт", label: "Батлан даалт" },
  { value: "Шаардахгүй", label: "Шаардахгүй" },
];

const CAR_DEALER_OPTIONS = [
  { value: "OFFICIAL_DEALERSHIP", label: "Албан ёсны төлөөлөгч" },
  { value: "SUPPLIER_ORGANIZATION", label: "Нийлүүлэгч байгуулага" },
  { value: "OTHER", label: "Бусад" },
  { value: "NOT_REQUIRED", label: "Шаардлагагүй" },
];

export default function CompareSection({ loanType }) {
  return (
    <>
      <Form.Item label="Жилийн хүү (%)">
        <div style={{ display: "flex", gap: 8 }}>
          <Form.Item name="minAnnualInterest" noStyle>
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              step={0.1}
              placeholder="Хамгийн бага"
            />
          </Form.Item>
          <span style={{ lineHeight: "32px", color: "#999" }}>–</span>
          <Form.Item name="maxAnnualInterest" noStyle>
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              step={0.1}
              placeholder="Хамгийн их"
            />
          </Form.Item>
        </div>
      </Form.Item>

      <Form.Item label="Бодит өртөг (%)">
        <div style={{ display: "flex", gap: 8 }}>
          <Form.Item name="minEffectiveInterest" noStyle>
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              step={0.1}
              placeholder="Хамгийн бага"
            />
          </Form.Item>
          <span style={{ lineHeight: "32px", color: "#999" }}>–</span>
          <Form.Item name="maxEffectiveInterest" noStyle>
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              step={0.1}
              placeholder="Хамгийн их"
            />
          </Form.Item>
        </div>
      </Form.Item>

      <Form.Item label="Валютын төрөл" name="currencyTypes">
        <Select options={CURRENCY_OPTIONS} placeholder="Сонгох" />
      </Form.Item>

      <Form.Item name="serviceFee" label="Үйлчилгээний шимтгэл (%)">
        <InputNumber
          style={{ width: "100%" }}
          min={0}
          formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          parser={(v) => v.replace(/,/g, "")}
          placeholder="0"
        />
      </Form.Item>

      <Form.Item name="collateralTypes" label="Барьцаа хөрөнгө">
        <Select
          mode="multiple"
          placeholder="Сонгох"
          options={COLLATERAL_OPTIONS}
        />
      </Form.Item>

      <Form.Item
        name="creditBureauFee"
        label="Зээлийн мэдээллийн сангийн лавлагаа (₮)"
      >
        <InputNumber
          style={{ width: "100%" }}
          min={0}
          formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          parser={(v) => v.replace(/,/g, "")}
          placeholder="0"
        />
      </Form.Item>

      <Form.Item name="downPayment" label="Урьдчилгаа төлбөр (%)">
        <InputNumber
          style={{ width: "100%" }}
          min={0}
          step={0.1}
          placeholder="0"
        />
      </Form.Item>

      <Form.Item name="earlyRepaymentFee" label="Эрт эргэн төлөх шимтгэл (%)">
        <InputNumber
          style={{ width: "100%" }}
          min={0}
          step={0.1}
          placeholder="0"
        />
      </Form.Item>

      {loanType === "BANK" && (
        <>
          <Divider
            orientation="left"
            plain
            style={{ fontSize: 12, color: "#888" }}
          >
            Банк — нэмэлт мэдээлэл
          </Divider>
          <Form.Item
            name="movableAssetsFee"
            label="Хөдлөх хөрөнгийн барьцаа бүртгэлийн хураамж (₮)"
          >
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              parser={(v) => v.replace(/,/g, "")}
              placeholder="0"
            />
          </Form.Item>
          <Form.Item
            name="loanApplicationFee"
            label="Зээлийн өргөдлийн хураамж (₮)"
          >
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              parser={(v) => v.replace(/,/g, "")}
              placeholder="0"
            />
          </Form.Item>
        </>
      )}

      {loanType === "NBFI" && (
        <>
          <Divider
            orientation="left"
            plain
            style={{ fontSize: 12, color: "#888" }}
          >
            ББСБ — нэмэлт мэдээлэл
          </Divider>
          <Form.Item name="loanRenewalFee" label="Зээлийн эрх шинэчлэх (₮)">
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              parser={(v) => v.replace(/,/g, "")}
              placeholder="0"
            />
          </Form.Item>
          <Form.Item
            name="loanClosingFee"
            label="Зээлийн эрх хаалгах хураамж (₮)"
          >
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              parser={(v) => v.replace(/,/g, "")}
              placeholder="0"
            />
          </Form.Item>
          <Form.Item
            name="limitIncreaseFee"
            label="Зээлийн эрх нэмэгдүүлэх (₮)"
          >
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              parser={(v) => v.replace(/,/g, "")}
              placeholder="0"
            />
          </Form.Item>
        </>
      )}

      <Divider orientation="left" plain style={{ fontSize: 12, color: "#888" }}>
        Машины зээл
      </Divider>
      <Form.Item name="carDealerType" label="Автомашин борлуулагч">
        <Select allowClear placeholder="Сонгох" options={CAR_DEALER_OPTIONS} />
      </Form.Item>
    </>
  );
}
